import { Navigate, Outlet, useLocation } from "react-router-dom";
import { WifiOff } from "lucide-react";
import { Button } from "@/components/ui/button";
import StatusScreen, { FullPageSpinner } from "@/components/StatusScreen";
import { useSession } from "./SessionContext";

const RequireSession: React.FC = () => {
  const { user, loading, loadError, retry, signOut } = useSession();
  const location = useLocation();

  if (loading) {
    return <FullPageSpinner />;
  }
  if (loadError) {
    return (
      <StatusScreen
        icon={WifiOff}
        tone="warning"
        title="De server is niet bereikbaar"
        description={`${loadError.message}. Je bent nog ingelogd; probeer het zo opnieuw.`}
        actions={
          <>
            <Button onClick={retry}>Opnieuw proberen</Button>
            <Button variant="outline" onClick={signOut}>
              Uitloggen
            </Button>
          </>
        }
      />
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <Outlet />;
};

export default RequireSession;
